import React from 'react';

import InputMask from 'react-input-mask';
import { Input } from '@useblu/ocean-react';

interface IInputProps {
  label: string;
  name: string;
  type?:
    | 'number'
    | 'text'
    | 'email'
    | 'password'
    | 'search'
    | 'tel'
    | 'url'
    | undefined;
  onChangeCB?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  defaultValue?: string;
  placeholder?: string;
  errors: any;
  register: any;
  mask?: string | null;
  disabled?: boolean;
  inputMode?:
    | 'text'
    | 'email'
    | 'search'
    | 'tel'
    | 'url'
    | 'numeric'
    | 'none'
    | 'decimal'
    | undefined;
  className?: string;
  autoComplete?: string;
}

type IInputmaskProps = {
  onChange: () => void;
  onBlur: () => void;
} & Pick<IInputProps, 'mask' | 'name' | 'onChangeCB'>;

const InputControl: React.FC<IInputProps> = ({
  label,
  name,
  type,
  onChangeCB,
  defaultValue,
  placeholder,
  errors,
  register,
  mask,
  className,
  autoComplete,
  disabled,
  inputMode = 'text',
}) => {
  const props = {
    className,
    helperText: errors[name] ? errors[name].message : '',
    error: Boolean(errors[name]?.message),
    autoComplete: autoComplete ?? 'on',
    inputMode,
  };

  if (mask) {
    let options = {};

    if (onChangeCB) {
      options = {
        onChange: (event: React.ChangeEvent<HTMLInputElement>) =>
          onChangeCB(event),
      };
    }

    const { ref, name: inputName, onChange } = register(name, options);

    return (
      <InputMask
        mask={mask}
        maskChar=""
        defaultValue={defaultValue}
        ref={ref}
        name={inputName}
        onChange={onChange}
      >
        {(inputProps: IInputmaskProps) => (
          <Input
            ref={ref}
            label={label}
            type={type || 'text'}
            placeholder={placeholder}
            disabled={disabled}
            {...props}
            {...inputProps}
          />
        )}
      </InputMask>
    );
  }

  const { onChange } = register(name);

  return (
    <Input
      label={label}
      type={type || 'text'}
      defaultValue={defaultValue}
      placeholder={placeholder}
      disabled={disabled}
      {...props}
      {...register(name)}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
        onChangeCB ? onChangeCB(event) : onChange(event)
      }
    />
  );
};

export default InputControl;
